import dayjs, { Dayjs } from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const dateUtils = {
  llFormat: (date: string) => {
    if (date) {
      return dayjs(date).format("MMMM DD, YYYY");
    }
    return date;
  },
  lllFormat: (date: string) => {
    if (date) {
      return dayjs(date).format("MMM DD, YYYY hh:mm A");
    }
    return date;
  },
  llllFormat: (date: string) => {
    if (date) {
      return dayjs(date).format("ddd, MMM DD, YYYY h:mm A");
    }
    return date;
  },

  localTime: (time: any) => {
    if (!time) return null;
    return dayjs(time).add(dayjs().utcOffset(), "minute");
  },
  utcTime: (time: any) => {
    if (!time) return null;
    return dayjs(time).add(-dayjs().utcOffset(), "minute");
  },
  getDateFromDateAndTime: (publishedDate: Date, publishedTime: Date) => {
    const year = publishedDate
      ? dayjs(publishedDate).get("year")
      : dayjs().get("year");
    const month = publishedDate
      ? dayjs(publishedDate).get("month")
      : dayjs().get("month");
    const date = publishedDate
      ? dayjs(publishedDate).get("date")
      : dayjs().get("date");
    const hour = publishedTime
      ? dayjs(publishedTime).get("hour")
      : dayjs().get("hour");
    const minute = publishedTime
      ? dayjs(publishedTime).get("minute")
      : dayjs().get("minute");
    const second = publishedTime
      ? dayjs(publishedTime).get("second")
      : dayjs().get("second");
    return dayjs()
      .set("year", year)
      .set("month", month)
      .set("date", date)
      .set("hour", hour)
      .set("minute", minute)
      .set("second", second)
      .format();
  },
  sameDate: (firstDate: Dayjs, secondDate: Dayjs) => {
    return (
      firstDate.get("date") === secondDate.get("date") &&
      firstDate.get("month") === secondDate.get("month") &&
      firstDate.get("year") === secondDate.get("year")
    );
  },
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  monthName: (month: number) => {
    return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][month - 1];
  },
  formatDateTime: (date: string | Date | Dayjs) => {
    return dayjs(date).fromNow();
  }
};

export default dateUtils;
